module.exports = __webpack_public_path__ + "img/Pankaj-Testimonial-1.32f09c6.png";